module.exports = __webpack_public_path__ + "img/innovation.54f4a6b5.png";